












import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import CourseContents from './components/landing/CourseContents.vue';
import CourseListing from './components/landing/CourseListing.vue';
import GetStarted from './components/landing/GetStarted.vue';
import LandingHero from './components/landing/LandingHero.vue';
import Motivation from './components/landing/Motivation.vue';
import TeachersFaq from './components/landing/TeachersFaq.vue';
import { meta } from 'frontend/utils/decorators';
import { educatorsPageFlowId } from 'frontend/components/util/Savvy/SavvyConstants';
import SavvyFlow from 'frontend/components/util/Savvy/SavvyFlow.vue';
import { FeatureSwitches } from 'frontend/types';

@Component({
  computed: {
    ...mapGetters('globals', ['featureSwitches']),
    ...mapGetters('response', ['baseUrl', 'requestPath']),
  },
  components: {
    CourseContents,
    CourseListing,
    GetStarted,
    LandingHero,
    Motivation,
    TeachersFaq,
    SavvyFlow,
  },
})
export default class TeacherLanding extends Vue {
  private readonly featureSwitches!: FeatureSwitches;
  private readonly baseUrl!: string;
  private readonly requestPath!: string;

  @meta
  private metaInfo() {
    const title = 'Brilliant for Educators | Free STEM Courses, Lessons & Puzzles';
    const description =
      'Transform how students think about math, science, CS and more with ' +
      'thousands of interactive lessons. Perfect for class warm-ups, math ' +
      'enrichment, nurturing giftedness, and inspiring every student. Free for ' +
      'qualified teachers.';
    return {
      titleTemplate: title,
      meta: [
        {
          name: 'description',
          vmid: 'description',
          content: description,
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: description,
        },
        { vmid: 'og:title', property: 'og:title', content: title },
        {
          vmid: 'og:url',
          property: 'og:url',
          content: `${this.baseUrl}${this.requestPath.split('?')[0]}`,
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          content:
            'https://brilliant.org/site_media/version-d36afe2dd2/images/open-graph/default.png',
        },
        { vmid: 'twitter:site', name: 'twitter:site', content: '@brilliantorg' },
        { vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
      ],
    };
  }

  private get flowId(): string {
    return educatorsPageFlowId;
  }

  private get savvyEnabled(): boolean {
    return this.featureSwitches.enable_savvy_educators_landingpage === true;
  }
}
